<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <div class="mt-28px">
      <h5><i class="dot"></i>비상조치계획 개요</h5>
      <div class="writeGridContainer">
        <div>
          <div>장소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input v-else v-model="form.inputB_1" />
        </div>
        <div>
          <div>점검일</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <date-selector :readonly="board.readonly" v-else v-model="form.inputB_2" />
        </div>
        <div>
          <div>재해형태</div>
          <p v-if="isPrint" class="print-input" style="color: red">{{ form.inputB_3 }}</p>
          <disaster-class-selector v-else :readonly="board.readonly" v-model="form.inputB_3" style="color: red" />
        </div>
      </div>
    </div>

    <!-- 비상조치계획 점검표 -->
    <TableInspectMerge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="비상조치계획 점검표"
      tableHeaderTitle="점검 내용"
      :tableHeaderCheck="[{ text: '양호' }, { text: '미흡' }, { text: '해당없음' }]"
      :isNote="false"
      v-model="form.inspectList"
      class="mt-28px"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="신축현장 점검" class="mt-28px" />

    <!--    파일첨부-->
    <file-upload-module v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" class="mt-28px"></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";

export default {
  components: {
    DisasterClassSelector,
    FileUploadModule,
    TableInspectMerge,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "비상조치계획 점검표",
      form: {
        inspectionTitle: "비상조치계획 점검표",
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        stdInfo: {},
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: [
          {
            content: "위험요인별로 어떤 재해가 발생할 수 있는지를 검토하여 중대재해로 이어질 수 있는 재해요인 파악",
            isChecked: "",
          },
          {
            content: "발생 가능한 사고의 유형 및 형태, 사고 발생 시 초래될 결과 등 확인･예측",
            isChecked: "",
          },
          {
            content: "본청･사업소별 위험성이 높은 위험요인에 대해 재해발생 시나리오 작성",
            isChecked: "",
          },
          {
            content: "재해발생 시나리오별 조치계획을 작성하여 관계 부서, 공정, 유해･위험물질, 재해유형, 원인, 피해범위 등을 목록화하여 관리",
            isChecked: "",
          },
          {
            content: "비상조치계획에는 필요한 인력 및 시설･장비(인적･물적 자원)를 적절히 포함",
            isChecked: "",
          },
          {
            content: "비상조치계획에 작업중지･근로자 대피･위험요인 제거 등 대응조치, 재해자구호조치, 추가피해 방지를 위한 조치 포함",
            isChecked: "",
          },
          {
            content: "비상조치계획에 상황 보고 및 전파체계, 조치별 대응조직 및 담당자의역할 구분",
            isChecked: "",
          },
          {
            content: "비상시 즉각 탈출할 수 있는 비상구가 충분히 마련되었고, 즉각 알아볼 수 있는 형태로 표시",
            isChecked: "",
          },
          {
            content: "비상상황에 대비한 병원, 소방서 등 유관 기관과의 협조체계 마련",
            isChecked: "",
          },
          {
            content: "비상조치계획에 따라 주기적으로 훈련하고 적정성 검토(반기 1회 이상) 및 이행",
            isChecked: "",
          },
          {
            content: "훈련과정에서 발견된 문제점을 검토하여 개선 조치 이행",
            isChecked: "",
          },
        ],
      },
    };
  },
};
</script>
